module.exports = {
      id: "health-usage",
      viewBox: "0 0 26.46 26.46",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#health",
      toString: function () {
        return this.url;
      }
    }